// The voicemail symbol (two reels joined by tape) for CRM-1830's pre-recorded
// voicemails; the icon set has none.
export const VoicemailGlyph = ({ size = 20 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    className="shrink-0"
  >
    <circle cx="6.5" cy="12" r="3.75" stroke="currentColor" strokeWidth="1.5" />
    <circle
      cx="17.5"
      cy="12"
      r="3.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 15.75h11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
